import axiosInstance from '@/services/axiosInstance'

async function renovateCard (number, image = '') {
  const data = {
    nSocio: number,
    esNuevaFoto: !!image,
    base64Foto: image
  }
  const req = {
    url: '/rgcc-services/FuncionesSW/RenovarTarjetaSocio',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data?.return_value
}

export {
  renovateCard
}
